import { useState } from "react";
import { Menu, X, ChevronRight, Shield, Heart, Award, Users, Phone, Mail, Clock, Star, Quote } from "lucide-react";

export default function Testimonials() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  // Testimonial data
  const testimonials = [
    {
      id: 1,
      name: "Margaret Wilson",
      age: 68,
      location: "Dallas, TX",
      image: "/api/placeholder/100/100",
      rating: 5,
      text: "After struggling to find affordable health insurance at my age, Optimal Actuarion was a blessing. Their senior-focused plans saved me over $200 monthly while providing better coverage than my previous insurer.",
      type: "Health Insurance"
    },
    {
      id: 2,
      name: "Robert Johnson",
      age: 72,
      location: "Fort Worth, TX",
      image: "/api/placeholder/100/100",
      rating: 5,
      text: "The team at Optimal Actuarion walked me through every step of choosing the right life insurance policy. Their patience and expertise made a complicated process feel simple and stress-free.",
      type: "Life Insurance"
    },
    {
      id: 3,
      name: "Maria Gonzalez",
      age: 65,
      location: "Arlington, TX",
      image: "/api/placeholder/100/100",
      rating: 5,
      text: "As someone from an underserved community, I've often felt overlooked by insurance companies. Optimal Actuarion treated me with respect and found me coverage I could actually afford.",
      type: "Health Insurance"
    },
    {
      id: 4,
      name: "David Chen",
      age: 70,
      location: "Irving, TX",
      image: "/api/placeholder/100/100",
      rating: 4,
      text: "When my previous insurer raised my premiums by 35%, I thought I'd have to go without coverage. Optimal Actuarion found me comparable protection at a price that works with my fixed income.",
      type: "Health Insurance"
    },
    {
      id: 5,
      name: "James & Patricia Miller",
      age: 67,
      location: "Plano, TX",
      image: "/api/placeholder/100/100",
      rating: 5,
      text: "We needed to update our life insurance policies after retirement but were concerned about costs. Optimal Actuarion designed a perfect solution that gave us peace of mind without breaking the bank.",
      type: "Life Insurance"
    },
    {
      id: 6,
      name: "Sarah Thompson",
      age: 63,
      location: "Richardson, TX",
      image: "/api/placeholder/100/100",
      rating: 5,
      text: "The personalized attention I received was outstanding. They took the time to understand my specific healthcare needs and found coverage that addressed my particular concerns.",
      type: "Health Insurance"
    }
  ];

  // Handle next and previous testimonial navigation
  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  // Render stars based on rating
  const renderStars = (rating) => {
    return Array(5)
      .fill()
      .map((_, i) => (
        <Star
          key={i}
          className={`h-5 w-5 ${
            i < rating ? "text-yellow-400 fill-yellow-400" : "text-gray-300"
          }`}
        />
      ));
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        {/* Announcement bar */}
        <div className="bg-gradient-to-r from-[#002D62] to-[#0077B6] text-white text-center py-2 text-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="font-semibold mr-2">Limited Time:</span> Get up to 30% off your first year of coverage. 
            <a href="/promotion" className="font-bold underline ml-1 hover:text-blue-100 transition-colors">Learn more</a>
          </div>
        </div>
        
        <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-20">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <div className="mr-2 text-[#0077B6]">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <span className="text-2xl font-extrabold bg-gradient-to-r from-[#002D62] to-[#0077B6] bg-clip-text text-transparent">Optimal Actuarion</span>
              </div>
              <nav className="hidden md:ml-10 md:flex md:space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Home</a>
                <a href="/#/about" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">About Us</a>
                <a href="/#/services" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Services</a>
                <a href="/#/quote" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Get a Quote</a>
                <a href="/#/faqs" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">FAQs</a>
                <a href="/#/testimonials" className="text-[#002D62] font-bold border-b-2 border-[#0077B6] px-1 pt-2 pb-1 transition-colors">Testimonials</a>
                <a href="/#/contact" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Contact</a>
              </nav>
            </div>
            <div className="flex items-center">
              <div className="hidden md:flex md:items-center md:space-x-4">
                <a href="/login" className="text-[#002D62] font-medium hover:text-[#0077B6] mr-4 transition-colors">Login</a>
                <a href="/quote" className="bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-6 py-3 rounded-md font-bold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
                  Get a Free Quote
                </a>
              </div>
              <div className="flex md:hidden">
                <button
                  type="button"
                  className="text-gray-700 hover:text-[#002D62] transition-colors"
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  aria-expanded={mobileMenuOpen}
                >
                  {mobileMenuOpen ? (
                    <X className="h-6 w-6" />
                  ) : (
                    <Menu className="h-6 w-6" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg animate-fadeIn">
            <div className="pt-2 pb-4 space-y-1 px-4">
            <a href="/" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Home</a>
              <a href="/#/about" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">About Us</a>
              <a href="/#/services" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Services</a>
              <a href="/#/quote" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Get a Quote</a>
              <a href="/#/faqs" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">FAQs</a>
              <a href="/#/testimonials" className="block py-2 text-[#002D62] font-bold border-l-4 border-[#0077B6] pl-3">Testimonials</a>
              <a href="/#/contact" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Contact</a>
             <div className="pt-4 pb-2 space-y-2">
                <a href="/login" className="block text-center text-[#002D62] font-medium hover:text-[#0077B6] py-2 transition-colors">
                  Login
                </a>
                <a href="/quote" className="w-full flex items-center justify-center bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-4 py-3 rounded-md font-bold shadow-md transition-all hover:shadow-lg">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </div>
        )}
      </header>

      <main>
        {/* Hero section */}
        <div className="bg-[#E8F1F9]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-[#002D62]">
                Our Client <span className="text-[#0077B6]">Success Stories</span>
              </h1>
              <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
                Don't just take our word for it. Hear directly from our clients about their experiences with Optimal Actuarion's insurance solutions.
              </p>
            </div>
          </div>
        </div>

        {/* Featured testimonial (Carousel) */}
        <div className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-extrabold text-[#002D62]">Featured Testimonials</h2>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
                Discover how we've helped seniors and underserved communities find affordable insurance coverage.
              </p>
            </div>

            <div className="relative bg-gradient-to-r from-[#002D62] to-[#0077B6] rounded-xl p-8 text-white shadow-xl">
              <div className="absolute top-4 left-4 text-[#E8F1F9] opacity-40">
                <Quote className="h-12 w-12" />
              </div>
              
              <div className="relative z-10">
                <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="h-24 w-24 rounded-full overflow-hidden border-4 border-white">
                      <img 
                        src={testimonials[activeTestimonial].image} 
                        alt={testimonials[activeTestimonial].name} 
                        className="object-cover w-full h-full"
                      />
                    </div>
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-center mb-3">
                      {renderStars(testimonials[activeTestimonial].rating)}
                    </div>
                    
                    <p className="text-lg md:text-xl italic mb-6">
                      "{testimonials[activeTestimonial].text}"
                    </p>
                    
                    <div>
                      <p className="font-bold text-xl">{testimonials[activeTestimonial].name}, {testimonials[activeTestimonial].age}</p>
                      <p className="text-[#E8F1F9]">
                        {testimonials[activeTestimonial].location} | {testimonials[activeTestimonial].type}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="absolute bottom-8 right-8 flex space-x-3">
                <button 
                  onClick={prevTestimonial}
                  className="p-2 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all"
                  aria-label="Previous testimonial"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button 
                  onClick={nextTestimonial}
                  className="p-2 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 transition-all"
                  aria-label="Next testimonial"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
              
              {/* Dots indicator */}
              <div className="flex justify-center space-x-2 mt-6">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveTestimonial(index)}
                    className={`h-2 rounded-full transition-all ${
                      index === activeTestimonial ? "w-8 bg-white" : "w-2 bg-white bg-opacity-50"
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* All testimonials grid */}
        <div className="py-12 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-extrabold text-[#002D62]">Our Client Testimonials</h2>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
                Read what our clients have to say about their experience with Optimal Actuarion.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial) => (
                <div 
                  key={testimonial.id} 
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="p-6">
                    <div className="flex items-center mb-4">
                      <div className="h-12 w-12 rounded-full overflow-hidden mr-4">
                        <img 
                          src={testimonial.image} 
                          alt={testimonial.name} 
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="font-bold text-[#002D62]">{testimonial.name}, {testimonial.age}</h3>
                        <p className="text-sm text-gray-600">{testimonial.location}</p>
                      </div>
                    </div>
                    
                    <div className="flex mb-3">
                      {renderStars(testimonial.rating)}
                    </div>
                    
                    <div className="text-gray-700">
                      <p className="italic">"{testimonial.text}"</p>
                    </div>
                    
                    <div className="mt-4 pt-4 border-t border-gray-100">
                      <span className="inline-block bg-[#E8F1F9] text-[#0077B6] px-3 py-1 rounded-full text-sm font-medium">
                        {testimonial.type}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Share your story section */}
        <div className="bg-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-[#E8F1F9] rounded-xl p-8 md:p-12">
              <div className="md:flex md:items-center md:justify-between">
                <div className="md:w-2/3">
                  <h2 className="text-2xl md:text-3xl font-bold text-[#002D62]">Share Your Optimal Actuarion Story</h2>
                  <p className="mt-3 text-lg text-gray-700">
                    We'd love to hear about your experience with our insurance solutions. Your feedback helps us improve and assists others in making informed decisions.
                  </p>
                </div>
                <div className="mt-6 md:mt-0">
                  <a 
                    href="/contact" 
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#0077B6] hover:bg-[#002D62] transition-colors"
                  >
                    Submit Your Testimonial
                    <ChevronRight className="ml-2 h-5 w-5" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats section */}
        <div className="bg-[#002D62] py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-extrabold text-white">Client Satisfaction</h2>
              <p className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto">
                Our dedication to exceptional service and affordable coverage speaks through our numbers.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white bg-opacity-10 rounded-lg p-6 text-center">
                <p className="text-4xl font-bold text-white">98%</p>
                <p className="mt-2 text-gray-300">Client Satisfaction</p>
              </div>
              
              <div className="bg-white bg-opacity-10 rounded-lg p-6 text-center">
                <p className="text-4xl font-bold text-white">300+</p>
                <p className="mt-2 text-gray-300">Senior Citizens Insured</p>
              </div>
              
              <div className="bg-white bg-opacity-10 rounded-lg p-6 text-center">
                <p className="text-4xl font-bold text-white">$1.2M</p>
                <p className="mt-2 text-gray-300">Annual Client Savings</p>
              </div>
              
              <div className="bg-white bg-opacity-10 rounded-lg p-6 text-center">
                <p className="text-4xl font-bold text-white">4.9/5</p>
                <p className="mt-2 text-gray-300">Average Client Rating</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <div className="md:flex md:items-center md:space-x-8">
              <div className="md:w-2/3 mb-6 md:mb-0">
                <h2 className="text-3xl font-bold text-[#002D62]">Join our community of satisfied clients</h2>
                <p className="mt-3 text-lg text-gray-700">
                  Experience the Optimal Actuarion difference with personalized insurance solutions that put people first.
                </p>
              </div>
              <div className="md:w-1/3 flex justify-center md:justify-end">
                <a href="/quote" className="w-full md:w-auto inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-white bg-[#0077B6] hover:bg-[#002D62]">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#002D62] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Optimal Actuarion LLC</h3>
              <p className="mb-4">Insurance solutions for everyone, with a special focus on senior citizens and underserved communities.</p>
              <div className="flex flex-col space-y-2">
                <a href="/about" className="hover:text-gray-300">About Us</a>
                <a href="/services" className="hover:text-gray-300">Services</a>
                <a href="/testimonials" className="hover:text-gray-300">Testimonials</a>
                <a href="/faqs" className="hover:text-gray-300">FAQs</a>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Contact Information</h3>
              <div className="flex flex-col space-y-3">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Phone className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>972-891-8635</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Mail className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>OptimalActuarion@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Clock className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>Monday-Friday: 9:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Office Locations</h3>
              <div className="mb-4">
                <p className="font-medium">Primary Office:</p>
                <p>3221 Finley Road,</p>
                <p>Irving, TX 75062</p>
              </div>
              <div>
                <p className="font-medium">Business Address:</p>
                <p>4020 N MacArthur Blvd,</p>
                <p>Ste 122 #7156,</p>
                <p>Irving, TX 75038</p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-center text-sm">© {new Date().getFullYear()} Optimal Actuarion LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}